/** +10% trip time for each survivor beyond the first (party coordination / wear). */
const DURATION_MULT_PER_EXTRA_SURVIVOR = 0.1

export function partyExpeditionDurationMultiplier(survivorCount: number): number {
  const n = Math.max(1, Math.floor(survivorCount))
  return 1 + DURATION_MULT_PER_EXTRA_SURVIVOR * (n - 1)
}

export function scaledExpeditionDurationMs(
  baseDurationMs: number,
  survivorCount: number,
  vehicleDurationMultiplier: number = 1,
): number {
  const mult = partyExpeditionDurationMultiplier(survivorCount)
  const vehicleMult = Number.isFinite(vehicleDurationMultiplier)
    ? Math.max(0.1, vehicleDurationMultiplier)
    : 1
  return Math.round(baseDurationMs * mult * vehicleMult)
}

/**
 * Trip length label: `1h:05m` when ≥1h; under 1h use `42m` or `1m 30s` when not a whole minute;
 * under 1 minute use `45s`.
 */
export function formatTripDurationCompact(ms: number): string {
  const n = Math.max(0, Math.round(ms))
  if (n === 0) return '0m'
  const totalS = Math.round(n / 1000)
  if (totalS < 60) return `${Math.max(1, totalS)}s`

  const h = Math.floor(totalS / 3600)
  if (h > 0) {
    const remS = totalS % 3600
    const m = Math.floor(remS / 60)
    return `${h}h:${String(m).padStart(2, '0')}m`
  }

  const m = Math.floor(totalS / 60)
  const s = totalS % 60
  if (s === 0) return `${m}m`
  return `${m}m ${s}s`
}
